import { render } from "./level-management.vue?vue&type=template&id=73245a62&scoped=true"
import script from "./level-management.vue?vue&type=script&lang=js"
export * from "./level-management.vue?vue&type=script&lang=js"

import "./level-management.vue?vue&type=style&index=0&id=73245a62&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73245a62"]])

export default __exports__